<template>
  <div>
    <v-app-bar class="top-bar" flat>
      <v-app-bar-title>
        <template v-slot:text>
          <v-img class="logo" src="@/assets/img/logo.png" @click="homeNavigation">
            <template v-slot:placeholder>
              <image-loader></image-loader>
            </template>
          </v-img>
        </template>
      </v-app-bar-title>
      <div class="wrap-top-action">
        <user-avatar v-if="isLoggedIn"></user-avatar>
      </div>
    </v-app-bar>
  </div>
</template>

<script setup>
import {useRouter} from "vue-router";
import ImageLoader from "@/components/ImageLoader.vue";
import {useUserStore} from "../stores/user.js";
import {storeToRefs} from "pinia";
import UserAvatar from "./UserAvatar.vue";
import {URLS_FACTORY} from "@/router/urls.js";

const $router = useRouter();
const userStore = useUserStore();
const {isLoggedIn} = storeToRefs(userStore);

function homeNavigation(){
  $router.push(URLS_FACTORY.URLS_PATHS.ROOT);
}
</script>

<style lang="less" scoped></style>
